import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { zhCN, enUS } from './lang/index'

Vue.use(VueI18n)

export default new VueI18n({
  locale: sessionStorage.getItem('lang') || 'zh_CN',
  messages: {
    zh_CN: { ...zhCN },
    en_US: { ...enUS }
  }
})